'use strict';

import angular from 'angular';
import FormController from 'app/controllers/form';


class CheckController extends FormController {
    /* @ngInject */
    constructor(ChecksService, ClientsService,
                $scope, $window, $mdDialog, $mdMenu) {
        let check = $scope.$parent.$resolve.check;
        super(check, 'Cheque', ChecksService);

        Object.assign(this, {ChecksService, ClientsService,
                             $scope, $window, $mdDialog, $mdMenu});
        this.btnEnabled = true;
    }

    $onInit() {
        super.$onInit();
        this.client = this.model.client;
    }

    queryClientSearch() {
        return this.ClientsService.find({
            filter: {
                where: {
                    name: {
                        regexp: `^${this.searchClientText}/i`
                    }
                }
            }
        });
    }

    selectedClientChange(client) {
        if (client) {
            this.model.client = client;
            this.client = client;
        }
    }

}

export default CheckController;
